(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.zf-product-card__swatch');
    if (!swatch) return;

    var card = swatch.closest('.zf-product-card');
    if (!card) return;

    var newImage = swatch.getAttribute('data-image');
    var newUrl = swatch.getAttribute('data-url');

    if (newImage) {
      e.preventDefault();

      var img = card.querySelector('.zf-product-card__img');
      if (img) {
        img.src = newImage;
      }

      if (newUrl) {
        var mainLink = card.querySelector('.zf-product-card__link');
        var buyBtn = card.querySelector('.zf-product-card__buybtn');
        if (mainLink) mainLink.setAttribute('href', newUrl);
        if (buyBtn) buyBtn.setAttribute('href', newUrl);
      }

      var siblings = swatch.parentElement.querySelectorAll('.zf-product-card__swatch');
      siblings.forEach(function (el) {
        el.classList.remove('is-active');
      });
      swatch.classList.add('is-active');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
